<template>
  <div class="select-form-cell">
    <van-field
        v-model="value"
        :name="name + 'Value'"
        :label="label"
        :label-width="labelWidth || 140"
        :placeholder="placeholder"
        @click="onSelect"
        :required="true"
        readonly
        :clickable="editor"
        :rules="[{ required: true, message: '请选择' }]"
    >
      <template #right-icon>
        <van-icon name="arrow" v-if="editor"/>
      </template>
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
          show-toolbar
          :columns="columns"
          :default-index="index"
          @confirm="onConfirm"
          @cancel="showPicker = false"
      />
    </van-popup>
    <van-field v-model="index" :name="name" v-show="false"/>
  </div>
</template>

<script>
export default {
  name: "selectFormCell",
  props: {
    label: String,
    name:String,
    select: {
      type: Number,
      default: -1
    },
    columns: Array,
    placeholder: String,
    labelWidth: Number,
    editor: Boolean
  },
  data() {
    return {
      value: this.columns[this.select],
      index: this.select,
      showPicker: false
    }
  },
  watch: {
    select(newValue, oldValue) {
      // console.log('select watch ', newValue, oldValue)
      this.index = newValue
      this.value = this.columns[newValue]
      // console.log('select watch ', this.value)
    }
    // select: {
    //   handler: (newValue, oldValue) => {
    //     // debugger
    //     console.log('select ', newValue, oldValue)
    //       this.index = newValue
    //       this.value = this.columns[newValue]
    //     // this.$nextTick(() => {
    //     //   console.log('handler => this.columns ', this.columns)
    //     //   this.value = this.columns[val]
    //     // })
    //
    //     // debugger
    //   },
    //   immediate: true
    // },
  },
  methods: {
    onConfirm(value, index) {
      // console.log('onConfirm => value ', value, index)
      this.value = value
      this.index = index
      this.$emit('change', index)
      this.showPicker = false
    },
    onSelect(value) {
      if (!this.editor) {
        return
      }
      this.showPicker = true
      // console.log('onSelect => onSelect ', value)
    }
  }
}
</script>

<style lang="less">
.select-form-cell {
  //.van-field--disabled .van-field__label {
  //  color: #646566;
  //}
  .van-picker__confirm {
    color: #3D8AFF;
  }
  .van-picker__cancel {
    color: #3D8AFF;
  }
  .van-cell {
    padding: 10px 16px 10px 22px !important;
  }
  .van-cell--required::before {
    left: 14px !important;
  }
  .van-field__label {
    font-size: 13px;
    font-weight: 400;
    color: #3F403F;
  }
  .van-picker-column__item--selected {
    font-size: 18px !important;
  }
}
</style>
<style scoped lang="less">
.select-form-cell {

}
</style>



// WEBPACK FOOTER //
// src/modules/marketCenter/formCell/selectFormCell.vue